import { BankSecurityEvent } from '../../models/supplier.model';
import { Event } from '../../models/event.model';

export class EventState {
    Event: Event;
    SecurityEvent: BankSecurityEvent
}

export const intitialState: EventState = {
    Event: null,
    SecurityEvent: null
};